/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/megaphone'
export default icon
